<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
        {{ $t('records_list.export.modal.title') }}
      </h5>
    </template>

    <template #body>
      <form @submit.prevent="exportRecords()">
        <div class="modal-body">
          <p>
            {{ $t('records_list.export.modal.body', { email: user.email }) }}
          </p>

          <hr>

          <p>
            <small>
              {{ $t('records_list.export.modal.help_message') }}
            </small>
          </p>
        </div>
        <div class="modal-footer">
          <input @click.prevent='$refs.modal.close' type='submit' :value="$t('records_list.export.modal.buttons.cancel')" class="btn btn-outline-primary">

          <input type="submit" :value="$t('records_list.export.modal.buttons.export')" class="btn btn-primary float-right" />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        user: {},
      }
    },
    computed: {
      recordColumns() {
        if (!this.user.defaults)
          return []

        return this.user.defaults.items || []
      },
    },
    methods: {
      open(user) {
        this.user = Object.assign({}, user)
        this.$refs.modal.open()
      },
      exportRecords() {
        this.store.exportRecord({ columns: this.recordColumns }).then(() => {
          this.store.sendMetrics({name: 'export_files', params: this.$route.params, path: this.$route.fullPath})
          this.$refs.modal.close()
          this.$toastr.success(this.$t('records_list.export.success_message'))
        })
      }
    }
  }
</script>
